import { site } from "../content";
import { Icon } from "./Icon";
import { Reveal, SectionHeading } from "./Reveal";

export default function Warranty() {
  return (
    <section id="garantia" data-testid="warranty-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="13"
          eyebrow="Garantia e suporte"
          title="Você não compra apenas o equipamento."
          subtitle="Conte com suporte pós-venda, peças de reposição e 12 meses de garantia contra defeitos de fabricação."
          testId="warranty-heading"
        />

        <div className="mt-14 grid grid-cols-2 gap-5 lg:grid-cols-4">
          {site.warranty.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08}>
              <div
                data-testid={`warranty-card-${i}`}
                className="flex h-full flex-col items-center gap-4 rounded-2xl border border-white/10 bg-graphite/60 p-7 text-center backdrop-blur-xl transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-gold/40"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/25 bg-gold/[0.07] text-gold">
                  <Icon name={item.icon} className="h-5 w-5" />
                </div>
                <h3 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-bone md:text-sm">
                  {item.title}
                </h3>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-center text-sm text-bone/50" data-testid="warranty-responsible">
            Suporte e responsável técnico:{" "}
            <span className="font-semibold text-bone/80">{site.responsible}</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
